"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiFilter16 = {
    paths: [
        {
            path: 'M12.9931545,11 C13.509501,11 13.9350657,11.3827202 13.9932262,11.8826674 L14,12 C14,12.5522847 13.5500512,13 12.9931545,13 L1.00684547,13 C0.450780073,13 0,12.5561352 0,12 C0,11.4477153 0.449948758,11 1.00684547,11 L12.9931545,11 Z M2,5 C2.74025244,5 3.38657394,5.40216612 3.73239368,5.99992752 L12.9931545,6 C13.509501,6 13.9350657,6.38272018 13.9932262,6.88266744 L14,7 C14,7.55228475 13.5500512,8 12.9931545,8 L3.73181186,8.0010775 C3.38584934,8.59828461 2.7398375,9 2,9 C0.8954305,9 0,8.1045695 0,7 C0,5.8954305 0.8954305,5 2,5 Z M12.9931545,1 C13.509501,1 13.9350657,1.38272018 13.9932262,1.88266744 L14,2 C14,2.55228475 13.5500512,3 12.9931545,3 L1.00684547,3 C0.450780073,3 0,2.55613518 0,2 C0,1.44771525 0.449948758,1 1.00684547,1 L12.9931545,1 Z M12,0 C13.1045695,0 14,0.8954305 14,2 C14,3.1045695 13.1045695,4 12,4 C10.8954305,4 10,3.1045695 10,2 C10,0.8954305 10.8954305,0 12,0 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Filter',
    width: 14,
    height: 14,
};
var muiFilter24 = {
    paths: [
        {
            path: 'M17,14 C18.6568542,14 20,15.3431458 20,17 C20,18.6568542 18.6568542,20 17,20 C15.6937812,20 14.5825421,19.1651924 14.1707057,18 L14.1707057,18 L0.998513042,18 C0.447049516,18 0,17.5561352 0,17 C0,16.4477153 0.452137557,16 0.998513042,16 L0.998513042,16 L14.1707057,16 C14.5825421,14.8348076 15.6937812,14 17,14 Z M3,7 C4.30621883,7 5.41745788,7.83480763 5.82929429,9 L19.001487,9 C19.5478624,9 20,9.44771525 20,10 C20,10.5561352 19.5529505,11 19.001487,11 L5.82929429,11 C5.41745788,12.1651924 4.30621883,13 3,13 C1.34314575,13 0,11.6568542 0,10 C0,8.34314575 1.34314575,7 3,7 Z M17,0 C18.6568542,0 20,1.34314575 20,3 C20,4.65685425 18.6568542,6 17,6 C15.6937812,6 14.5825421,5.16519237 14.1707057,4 L14.1707057,4 L0.998513042,4 C0.447049516,4 0,3.55613518 0,3 C0,2.44771525 0.452137557,2 0.998513042,2 L0.998513042,2 L14.1707057,2 C14.5825421,0.834807627 15.6937812,0 17,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Filter',
    width: 20,
    height: 20,
};
var muiFilter = {
    base: muiFilter16,
    smIcon: muiFilter16,
    lgIcon: muiFilter24,
};
exports.muiFilter = muiFilter;
//# sourceMappingURL=filter.js.map